<template>
	<v-container>
		<h2>Check if files were exported correctly from Airflow to S3</h2>
		<h5>This check is to verify that the process of query Peak DB -> fetch data -> write a file to S3 has been done correctly</h5>
		<v-progress-circular
			indeterminate
			color="primary"
			v-show="isLoading"
		></v-progress-circular>
		<v-data-table
			:headers=headersCollapsed
			:items="this.filesDatesCollapsed"
			:items-per-page="10"
			:expanded.sync="expanded"
			:sort-by.sync="columnNameToSortBy"
			:sort-desc.sync="isDescending"
			single-expand
			item-key="date"
			class="table"
			@click:row="clickedRow"
		>
			<template v-slot:expanded-item="{ headers, item }">
				<td :colspan="headers.length" class="expandableArea">
					<v-card>
						<v-data-table
							:headers=headersExpanded
							:items="filesDatesExpandedFiltered"
							:items-per-page="100"
							hide-default-footer
							hide-default-header
							@click:row="clickedExpandedRow"
						/>
					</v-card>
				</td>
			</template>
		</v-data-table>

		<v-dialog
			v-model="dialogReadS3File"
		>
			<v-card>
				<div>
				<h3>File {{ this.openedFileName }} contents</h3> <br/>
				<span style="white-space: pre; overflow: auto; display:block;">{{ this.openedFileContents }}</span>
				</div>
			</v-card>
		</v-dialog>
	</v-container>
</template>

<script>
import axios from "axios"
export default {
	name: 'AdminS3ExportHealthCheck',
	props: ['selectedMandators'],
	data() {
		return {
			filesDatesCollapsed: [],
			filesDatesExpanded: [],
			filesDatesExpandedFiltered: [],
			expanded: [],
			isLoading: false,
			columnNameToSortBy: 'date',
			isDescending: true,
			dialogReadS3File: false,
			openedFileName: '',
			openedFileContents: '',

			headersCollapsed: [{
				text: 'Mandator',
				align: 'start',
				sortable: 'true',
				value: 'mandator',
			}, {
				text: 'Date of export',
				align: 'start',
				sortable: true,
				value: 'date',
			}, {
				text: 'Number of files',
				align: 'start',
				sortable: true,
				value: 'numberOfFiles',
			}, {
				text: 'Size of files',
				align: 'start',
				sortable: true,
				value: 'fileSizeSum',
			}],
			headersExpanded: [{
				text: 'Date of export',
				align: 'start',
				sortable: true,
				value: 'date',
			}, {
				text: 'Filename',
				align: 'start',
				sortable: true,
				value: 'fileNameShort',
			}, {
				text: 'File size',
				align: 'start',
				sortable: true,
				value: 'fileSize',
			}, {
				text: 'Last updated at',
				align: 'start',
				sortable: true,
				value: 'modifiedAt',
			}],
		}
	},
	methods: {
		clickedRow(value) {
			this.filesDatesExpandedFiltered = this.filesDatesExpanded.filter((el) => el.date == value.date)
			this.expanded = this.expanded.length > 0 && this.expanded[0].date == value.date ? [] : [value]
		},
		async clickedExpandedRow(value) {
			const r = await axios.get(`${config.baseAPIurl}/admin-page/S3/read-file`, {
				params: {
					fileKey: value.fullFileName,
				},
			})
			this.dialogReadS3File = true
			this.openedFileName = value.fullFileName
			this.openedFileContents = r.data
		},
	},
	watch: {
		selectedMandators: {
			async handler() {
				try {
					if (!this.selectedMandators) {
						this.filesDatesExpanded = []
						this.filesDatesCollapsed = []
						return
					}
					this.isLoading = true
					// eslint-disable-next-line max-len
					const r = await axios.get(`${config.baseAPIurl}/admin-page/S3/revenue-health-check?installationId=${this.selectedMandators.value}`)
					// take only date part of the path
					this.filesDatesCollapsed = r.data.map((el) => el.split('/').slice(-2, -1)[0]).map((el) => ({
						date: el,
					}))
					// get details on files
					const fileDetailsPromises = []
					for (const fileDate of this.filesDatesCollapsed) {
						// eslint-disable-next-line max-len
						fileDetailsPromises.push(axios.get(`${config.baseAPIurl}/admin-page/S3/get-files?installationId=${this.selectedMandators.value}&dateOfExport=${fileDate.date}`))
					}
					// construct table ready object
					const fileDetailsResolved = (await Promise.all(fileDetailsPromises))
						.map((el, idx) => ({
							mandator: this.selectedMandators.text,
							details: el.data,
							date: this.filesDatesCollapsed[idx].date,
							numberOfFiles: el.data.KeyCount,
							fileSizeSum: `${Math.round(el.data.Contents.map((el) => el.Size).reduce((partialSum, a) => partialSum + a, 0) / 1024 * 100) / 100} KB`,
						}))
					const fileDetailsUngrouped = []
					// construct detailed view (upon clicking on row) immediately, later on just filter
					fileDetailsResolved.forEach((el) => {
						el.details.Contents.forEach((el2) => {
							let convertedValue = el2.Size / 1024 / 1024
							let unit = 'MB'
							if (convertedValue < 1) {
								convertedValue *= 1024
								unit = 'KB'
							}
							fileDetailsUngrouped.push({
								date: el.date,
								fileNameShort: el2.Key.split('/').slice(-1)[0],
								fullFileName: el2.Key,
								fileSize: `${Math.round(convertedValue * 100) / 100} ${unit}`,
								modifiedAt: el2.LastModified,
							})
						})
					})
					this.filesDatesCollapsed = fileDetailsResolved
					this.filesDatesExpanded = fileDetailsUngrouped
				} catch (error) {
					console.log(error)
					this.filesDatesExpanded = []
					this.filesDatesCollapsed = []
				} finally {
					this.isLoading = false
				}
			},
		},
	},
}
</script>
<style scoped>
.formEdit {
  padding: 25px;
  margin: 0;
  height: 50%;
  overflow: hidden;
}
</style>